<template>
  <div id="wdw-discuss-thought-form-choose-topic">
    <!-- <button v-if="showBackButton" class="btn btn-primary" @click="closeThoughtForm()">Zurück zur Liste</button> -->
    <div>
      <div class="wdw-form">
        <form-control-select
          v-if="avalibleTopics.length > 1"
          :label="topicLabel() + (appendLabel ? ' ' + appendLabel : '')"
          name="topic"
          :options="topicPair"
          :required="true"
          :shouldcache="false"
          :defaultvalue="[topic?.id + '']"
          @selected="selectedTopic($event, field)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { projectStore } from '@/store/project-store';
import { ref, computed, onMounted } from 'vue';
import FormControlSelect from '@/components/general/FormControl/Select';
import useTopicTerm from '@/composables/topic/useTopicTerm';

export default {
  name: 'ThoughtFormChooseTopic',
  components: {
    FormControlSelect,
  },
  props: {
    avalibleTopics: {
      type: Array,
      required: false,
      default: () => [],
    },
    appendLabel: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['topic-selected'],

  setup(props, context) {
    const choosenTopic = ref(null);
    const { topicLabel } = useTopicTerm();

    //--------------------------------COMPUTED-----------------------------------
    const project = computed(() => {
      return projectStore.getState().project;
    });

    //Used For The MultiSelect Options
    const topicPair = computed(() => {
      const options = [];
      props.avalibleTopics.forEach(t => {
        options.push({
          id: t.id + '',
          ordering: 1,
          text: t.title,
        });
      });
      return options;
    });

    //+------------------------+
    //|     other methods      |
    //+------------------------+

    const selectedTopic = (event, field) => {
      choosenTopic.value = props.avalibleTopics.filter(t => t.id == event.value)[0];
      context.emit('topic-selected', choosenTopic.value);
    };

    onMounted(() => {
      if (props.avalibleTopics.length === 1) {
        choosenTopic.value = props.avalibleTopics[0];
      }
    });

    return {
      //------------------Vars------------------
      choosenTopic,
      //---------------Computed-----------------
      project,
      topicPair,
      //-------------Other methods--------------
      selectedTopic,
      topicLabel,
    };
  },
};
</script>

<style scoped>
.image-preview {
  max-width: 200px;
  max-height: 150px;
}
</style>
